import { Grid } from '@material-ui/core';
import { FieldArray } from 'formik';
import React, { Fragment } from 'react';
import CompraProdutoItem from './CompraProdutoItem';
import { compraProdutoListStyles } from './styles';

const CompraProdutoList = ({
  id,
  name,
  errors,
  touched,
  onAddProduto,
  onChange,
  onBlur,
  value,
  onRemoveProduto,
  submitCount,
  compraPaga,
}) => {
  const styles = compraProdutoListStyles();

  return (
    <FieldArray
      name="produtos"
      render={(arrayHelpers) => {
        return (
          <>
            {value
              ?.filter((p) => !!p)
              ?.map((p, i) => {
                return (
                  <Fragment key={p.key}>
                    <CompraProdutoItem
                      values={p}
                      onChange={onChange}
                      onBlur={onBlur}
                      index={i}
                      id={`${id}[${i}]`}
                      name={`${name}[${i}]`}
                      errors={(errors?.length >= i && errors[i]) || {}}
                      touched={(touched?.length >= i && touched[i]) || {}}
                      arrayHelpers={arrayHelpers}
                      onRemove={onRemoveProduto}
                      showDivider={value?.length > 1 && i !== value?.length - 1}
                      submitCount={submitCount}
                      compraPaga={compraPaga}
                    />
                  </Fragment>
                );
              })}
            <Grid container spacing={3}>
              <Grid item xs={12}>
                {!compraPaga && (
                  <button className={styles.buttonAdicionarProduto} type="button" href="" onClick={onAddProduto}>
                    Adicionar produto
                  </button>
                )}
              </Grid>
            </Grid>
          </>
        );
      }}
    />
  );
};

export default CompraProdutoList;
